import styled from 'styled-components';

const OurCultureStyle = styled.div`
	--cultureItemsWrapMarginRight: var(--sp16x);
	--itemTitleMarginTopBottom: var(--sp4x) 0 var(--sp1-5x) 0;
	--itemWidth: calc(100% / 3);
	--distanceGap: var(--sp4x);
	--widthItemColRight: 20%;
	--paddingOurCulture: var(--sp16x);

	.culture-container {
		display: flex;

		.culture-items-wrap {
			margin-top: var(--sectionDistance);
			display: flex;
			flex-wrap: nowrap;
			gap: var(--distanceGap);

			.item-col {
				width: var(--itemWidth);
				transform: translateY(100px);

				.item-image {
					padding-top: 100%;
				}

				.item-title {
					margin: var(--itemTitleMarginTopBottom);
				}
			}
		}

		.item-col-right {
			width: var(--widthItemColRight);
			display: flex;
			align-items: center;
			justify-content: center;
			padding-left: var(--paddingOurCulture);

			p {
				width: var(--sp17x);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--cultureItemsWrapMarginRight: var(--sp8x);
		--itemTitleMarginTopBottom: var(--sp4x) 0 var(--sp1-5x) 0;
		--widthItemColRight: auto;
		--paddingOurCulture: var(--sp8x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--cultureItemsWrapMarginRight: var(--sp8x);
		--itemTitleMarginTopBottom: var(--sp3x) 0 var(--sp1-5x) 0;
		--distanceGap: var(--sp3x);
		--widthItemColRight: auto;
		--paddingOurCulture: var(--sp8x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--cultureItemsWrapMarginRight: var(--sp6x);
		--itemTitleMarginTopBottom: var(--sp2x) 0 var(--sp1-5x) 0;
		--distanceGap: var(--sp3x);
		--widthItemColRight: auto;
		--paddingOurCulture: var(--sp6x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--cultureItemsWrapMarginRight: 0;
		--itemTitleMarginTopBottom: var(--sp2x) 0 var(--sp1-5x) 0;
		--itemWidth: calc(100% / 3);

		--distanceGap: var(--sp3x);
		--widthItemColRight: auto;
		--paddingOurCulture: 0;

		margin-top: var(--sectionDistance);

		.culture-container {
			flex-direction: column-reverse;

			.culture-items-wrap {
				margin-top: 0;
			}

			.item-col-right {
				display: inline-block;
				width: 100%;
				transform: none;
				margin: 0;

				.culture-title {
					margin-bottom: var(--sp3x);
					max-width: var(--sp17x);
					transform: translateY(0);
				}

				p {
					padding: 0;
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--cultureItemsWrapMarginRight: 0;
		--itemTitleMarginTopBottom: var(--sp2x) 0 var(--sp1-5x) 0;
		--itemWidth: 100%;
		--distanceGap: 0;
		--widthItemColRight: auto;
		--paddingOurCulture: 0;

		margin-top: var(--sectionDistance);

		.culture-container {
			flex-direction: column-reverse;

			.culture-items-wrap {
				margin-top: 0;
			}

			.item-col-right {
				display: block;
				transform: none;
				margin: 0;

				.culture-title {
					margin-bottom: var(--sp3x);
					transform: translateY(0);
				}

				p {
					padding: 0;
				}
			}

			.culture-items-wrap {
				margin-top: calc(var(--sp2x) * -1);
				flex-wrap: wrap;

				.item-col {
					margin-top: var(--sp2x);
				}
			}
		}
	}
`;

export default OurCultureStyle;
